import { useLanguage } from "contexts/LanguageContext";
import Modal from "./Modal";
import { ExclamationTriangleIcon, PhotoIcon } from "@heroicons/react/24/outline";

interface ConfirmImageDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  imageUrl?: string;
}

const ConfirmImageDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  imageUrl
}: ConfirmImageDeleteModalProps) => {
  const { t } = useLanguage();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Kép törlése"
      size="sm"
    >
      <div className="p-4 space-y-4">
        <div className="flex items-center">
          <div className="flex-shrink-0 mr-3">
            <ExclamationTriangleIcon className="h-8 w-8 text-red-500 dark:text-red-400" />
          </div>
          <div className="flex-1">
            <p className="text-red-600 dark:text-red-400 font-semibold">Biztosan törli ezt a képet?</p>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">A törlés után a képet nem lehet visszaállítani.</p>
          </div>
        </div>

        {/* Kép előnézet */}
        {imageUrl && (
          <div className="mt-2 flex justify-center">
            <div className="border border-gray-200 dark:border-gray-600 rounded-lg p-1 bg-white dark:bg-gray-800 w-32 h-32 flex items-center justify-center">
              <img 
                src={imageUrl} 
                alt="Törlendő kép" 
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>
        )}

        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-xs font-medium rounded-md bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
          >
            Mégsem
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="px-4 py-2 text-xs font-medium rounded-md text-white bg-red-600 dark:bg-red-500 hover:bg-red-700 dark:hover:bg-red-600"
          >
            Törlés
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmImageDeleteModal; 